import { Injector, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderModule } from './nav-team/header/header.module';
import { FooterModule } from './nav-team/footer/header.module';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { ApiModule, Configuration } from 'src/libs/api-client';
import { ApiModule as ApiModule2 } from 'src/libs/api-client-jobms';
import { ApiModule as InvoiceApiModule } from 'src/libs/api-client-invoicems';
import { ApiModule as DirectoryApiModule} from 'src/libs/api-client-directoryms';
import { Configuration as Configuration2, } from 'src/libs/api-client-jobms';
import { Configuration as Configuration3, } from 'src/libs/api-client-invoicems';
import { Configuration as Configuration4, } from 'src/libs/api-client-directoryms';
import { BusinessIdService } from 'src/libs/shared-services/businessid.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { AuthInterceptor } from './auth-team/services/AuthInterceptor';
import { GlobalState } from './global.state';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { createCustomElement } from '@angular/elements';
import { ManualRequestsCustomElement } from './request-team/manual-requests/manual-requests-custom-element/manual-requests-custom-element.component';
import { ToastrModule } from 'ngx-toastr';
import { DateService } from 'src/libs/shared-services/date.service';
import { SwitchUserService } from 'src/libs/shared-services/switchuser.service';

@NgModule({ 
    declarations: [
        AppComponent
    ],
    bootstrap: [
        AppComponent
    ], 
    imports: [
        BrowserModule,
        AppRoutingModule,
        // header and footer modules
        HeaderModule,
        FooterModule,
        ApiModule.forRoot(() => {
            return new Configuration({
                basePath: environment.basePath,
            });
        }),
        ApiModule2.forRoot(() => {
            return new Configuration2({
                basePath: environment.basePath,
            });
        }),
        InvoiceApiModule.forRoot(() => {
            return new Configuration3({
                basePath: environment.basePath,
            });
        }),

        DirectoryApiModule.forRoot(() => {
            return new Configuration4({
                basePath: environment.basePath,
            });
        }),

        // firebase
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        // pagination package
        NgxPaginationModule,
        
        // https://github.com/scttcper/ngx-toastr
        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot(), // ToastrModule added
        
        // ManualRequestsCustomElement
    ], 
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        BusinessIdService,
        SwitchUserService,
        DateService,
        GlobalState,
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        provideClientHydration()
    ] 
})
export class AppModule { 

    constructor(private injector: Injector) {

        // const el = createCustomElement(ManualRequestsCustomElement, { injector });
        // customElements.define('manual-requests', el);

    }
}
